export default "__VITE_ASSET__d857183d__"